(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('country-selector')) {
    class CountrySelector extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.country-selector__toggle');
        this.list = this.querySelector('.country-selector__list');
        if (!this.toggle || !this.list) return;

        this.onToggleClick = () => (this.isOpen ? this.close() : this.open());
        this.onKeydown = (event) => this.handleKeydown(event);
        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.close(false);
        };
        this.onFocusOut = (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
        };

        this.toggle.addEventListener('click', this.onToggleClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggleClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      get links() {
        return Array.from(this.list.querySelectorAll('a'));
      }

      open(focusTarget) {
        this.list.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocumentClick);
        if (focusTarget === 'first') this.links[0]?.focus();
        if (focusTarget === 'last') this.links.at(-1)?.focus();
      }

      close(returnFocus = true) {
        if (!this.isOpen) return;
        this.list.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
        if (returnFocus) this.toggle.focus();
      }

      handleKeydown(event) {
        const links = this.links;
        const index = links.indexOf(document.activeElement);

        switch (event.key) {
          case 'Escape':
            if (this.isOpen) {
              event.preventDefault();
              this.close();
            }
            break;
          case 'ArrowUp':
            event.preventDefault();
            if (!this.isOpen) this.open('last');
            else links[index <= 0 ? links.length - 1 : index - 1]?.focus();
            break;
          case 'ArrowDown':
            event.preventDefault();
            if (!this.isOpen) this.open('first');
            else links[index === -1 || index === links.length - 1 ? 0 : index + 1]?.focus();
            break;
          case 'Home':
            if (this.isOpen && index !== -1) {
              event.preventDefault();
              links[0]?.focus();
            }
            break;
          case 'End':
            if (this.isOpen && index !== -1) {
              event.preventDefault();
              links.at(-1)?.focus();
            }
            break;
        }
      }
    }

    customElements.define('country-selector', CountrySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klaviyo-signup')) {
    /**
     * Submits the native email signup form to Klaviyo's client Subscriptions API
     * instead of creating a Shopify customer. Only rendered when a Klaviyo public
     * key and list ID are set on the block; otherwise the native form posts as normal.
     */
    class KlaviyoSignup extends HTMLElement {
      static API_URL = 'https://a.klaviyo.com/client/subscriptions/';
      static API_REVISION = '2024-10-15';
      static EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      // Listen on the element itself (submit bubbles) and resolve children lazily,
      // so it works even if the element upgrades before its children are parsed.
      connectedCallback() {
        this.onSubmit = (event) => this.handleSubmit(event);
        this.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('submit', this.onSubmit);
      }

      async handleSubmit(event) {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.button = this.querySelector('button');
        this.message = this.querySelector('.email-signup__message--klaviyo');
        if (!this.form || !this.input || !this.message) return;

        event.preventDefault();
        if (this.form.getAttribute('aria-busy') === 'true') return;

        const email = this.input.value.trim();
        if (!KlaviyoSignup.EMAIL_PATTERN.test(email)) {
          this.showMessage('error', this.dataset.invalidMessage);
          return;
        }

        this.setBusy(true);

        try {
          const response = await fetch(
            `${KlaviyoSignup.API_URL}?company_id=${encodeURIComponent(this.dataset.companyId)}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/vnd.api+json',
                revision: KlaviyoSignup.API_REVISION,
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: this.dataset.source || 'Footer signup',
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email,
                          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                        },
                      },
                    },
                  },
                  relationships: {
                    list: { data: { type: 'list', id: this.dataset.listId } },
                  },
                },
              }),
            }
          );

          if (response.ok) {
            this.form.reset();
            this.showMessage('success', this.dataset.successMessage);
          } else if (response.status === 400) {
            this.showMessage('error', this.dataset.invalidMessage);
          } else {
            this.showMessage('error', this.dataset.errorMessage);
          }
        } catch (error) {
          this.showMessage('error', this.dataset.errorMessage);
        } finally {
          this.setBusy(false);
        }
      }

      setBusy(isBusy) {
        this.form.setAttribute('aria-busy', String(isBusy));
        if (this.button) this.button.disabled = isBusy;
      }

      /**
       * @param {'success' | 'error'} type
       * @param {string} text
       */
      showMessage(type, text) {
        const isError = type === 'error';
        this.message.querySelector('[data-klaviyo-text]').textContent = text;
        this.message.querySelector('[data-klaviyo-icon="success"]').hidden = isError;
        this.message.querySelector('[data-klaviyo-icon="error"]').hidden = !isError;
        this.message.hidden = false;

        this.input.setAttribute('aria-describedby', this.message.id);
        if (isError) {
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus();
        } else {
          this.input.removeAttribute('aria-invalid');
        }
      }
    }

    customElements.define('klaviyo-signup', KlaviyoSignup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    // Height-fill groups stack into a mobile column with their natural
  // content height (see base.css), which is correct for avoiding cut-off
  // text but means two side-by-side "equal height" groups (e.g. a dual
  // image split) can end up visibly mismatched once stacked, since each
  // side's height is now driven only by its own content. This matches each
  // set of height-fill siblings within a mobile-stacked group to the
  // tallest one, using min-height so it only ever grows — never re-clips
  // content that already fit.
  function equalizeMobileGroupHeights() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('[data-mobile-equal-height]').forEach((el) => {
      el.style.minHeight = '';
      el.removeAttribute('data-mobile-equal-height');
    });

    if (!isMobile) return;

    document.querySelectorAll('.mobile-column').forEach((column) => {
      const candidates = Array.from(column.children).filter(
        (child) =>
          child.classList.contains('group-block--height-fill') &&
          !child.classList.contains('group-block--no-content')
      );
      if (candidates.length < 2) return;

      const maxHeight = Math.max(...candidates.map((el) => el.getBoundingClientRect().height));
      candidates.forEach((el) => {
        el.style.minHeight = maxHeight + 'px';
        el.setAttribute('data-mobile-equal-height', '');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeMobileGroupHeights);
  } else {
    equalizeMobileGroupHeights();
  }

  let equalizeMobileGroupHeightsTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(equalizeMobileGroupHeightsTimeout);
    equalizeMobileGroupHeightsTimeout = setTimeout(equalizeMobileGroupHeights, 150);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    /**
   * Builds the size guide tables from the size_guide metaobject JSON:
   * { "tabs": [{ "label", "columns": [], "rows": [{ "label", "values": [], "values_inch"?: [] }] }] }
   * The CM / INCH toggle only shows when at least one row provides `values_inch`.
   */
  function renderSizeGuide(root) {
    if (root.dataset.sizeGuideRendered) return;

    const script = root.parentElement.querySelector('[data-size-guide-json]');
    if (!script) return;

    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      return;
    }

    const tabs = data.tabs || [];
    if (!tabs.length) return;

    root.dataset.sizeGuideRendered = 'true';

    const uid = root.closest('dialog')?.id || 'size-guide';
    const tabsContainer = root.querySelector('[data-size-guide-tabs]');
    const panelsContainer = root.querySelector('[data-size-guide-panels]');
    const units = root.querySelector('[data-size-guide-units]');
    let hasInch = false;

    tabsContainer.hidden = tabs.length < 2;

    tabs.forEach((tab, index) => {
      const tabId = `${uid}-tab-${index}`;
      const panelId = `${uid}-panel-${index}`;

      if (tabs.length > 1) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.id = tabId;
        btn.className = 'size-guide__tab' + (index === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        btn.setAttribute('aria-controls', panelId);
        btn.tabIndex = index === 0 ? 0 : -1;
        btn.dataset.sizeGuideTab = String(index);
        btn.textContent = tab.label;
        tabsContainer.appendChild(btn);
      }

      const panel = document.createElement('div');
      panel.id = panelId;
      panel.className = 'size-guide__panel';
      panel.dataset.sizeGuidePanel = String(index);
      if (tabs.length > 1) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.tabIndex = 0;
      }
      if (index !== 0) panel.hidden = true;

      const table = document.createElement('table');
      table.className = 'size-guide__table';

      const thead = document.createElement('thead');
      const headRow = document.createElement('tr');
      const sizeHeader = document.createElement('th');
      sizeHeader.scope = 'col';
      sizeHeader.textContent = tab.size_label || 'Size';
      headRow.appendChild(sizeHeader);
      (tab.columns || []).forEach((col) => {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = col;
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      table.appendChild(thead);

      const tbody = document.createElement('tbody');
      (tab.rows || []).forEach((row) => {
        const tr = document.createElement('tr');
        const labelCell = document.createElement('th');
        labelCell.scope = 'row';
        labelCell.textContent = row.label;
        tr.appendChild(labelCell);

        const inch = Array.isArray(row.values_inch) ? row.values_inch : null;
        if (inch) hasInch = true;

        (row.values || []).forEach((val, i) => {
          const td = document.createElement('td');
          td.textContent = val;
          td.dataset.cm = val;
          if (inch && inch[i] != null) td.dataset.inch = inch[i];
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      panel.appendChild(table);
      panelsContainer.appendChild(panel);
    });

    if (units) units.hidden = !hasInch;
  }

  function selectSizeGuideTab(tab) {
    const content = tab.closest('.size-guide__content');
    content.querySelectorAll('[data-size-guide-tab]').forEach((el) => {
      const isActive = el === tab;
      el.classList.toggle('is-active', isActive);
      el.setAttribute('aria-selected', isActive ? 'true' : 'false');
      el.tabIndex = isActive ? 0 : -1;
    });
    content.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sizeGuidePanel !== tab.dataset.sizeGuideTab;
    });
  }

  document.querySelectorAll('[data-size-guide-root]').forEach(renderSizeGuide);

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-size-guide-tab]');
    if (tab) {
      selectSizeGuideTab(tab);
      return;
    }

    const unit = event.target.closest('[data-size-guide-unit]');
    if (unit) {
      const content = unit.closest('.size-guide__content');
      const system = unit.dataset.sizeGuideUnit;
      content.querySelectorAll('[data-size-guide-unit]').forEach((el) => {
        const isActive = el === unit;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      content.querySelectorAll('td[data-cm]').forEach((td) => {
        td.textContent = system === 'inch' && td.dataset.inch != null ? td.dataset.inch : td.dataset.cm;
      });
    }
  });

  // Arrow / Home / End keys move between size guide tabs (WAI-ARIA tabs pattern)
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest?.('[data-size-guide-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const tabs = Array.from(tab.parentElement.querySelectorAll('[data-size-guide-tab]'));
    const index = tabs.indexOf(tab);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;

    event.preventDefault();
    tabs[next].focus();
    selectSizeGuideTab(tabs[next]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["team-switcher"] && !Shopify.designMode) return;
  try {
    function closeListbox(switcher) {
    const trigger = switcher.querySelector('[data-team-switcher-trigger]');
    const listbox = switcher.querySelector('[data-team-switcher-listbox]');
    trigger.setAttribute('aria-expanded', 'false');
    listbox.hidden = true;
  }

  function openListbox(switcher) {
    const trigger = switcher.querySelector('[data-team-switcher-trigger]');
    const listbox = switcher.querySelector('[data-team-switcher-listbox]');
    trigger.setAttribute('aria-expanded', 'true');
    listbox.hidden = false;
  }

  function applyTeamOption(switcher, option) {
    if (!option) return;

    const section = switcher.closest('.media-content-split');
    const image = section ? section.querySelector('[data-team-switcher-image]') : null;
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.srcset = '';
    }

    const triggerLogo = switcher.querySelector('[data-team-switcher-trigger-logo]');
    if (triggerLogo) {
      if (option.dataset.logo) {
        triggerLogo.src = option.dataset.logo;
        triggerLogo.hidden = false;
      } else {
        triggerLogo.hidden = true;
      }
    }

    const triggerLabel = switcher.querySelector('[data-team-switcher-trigger-label]');
    if (triggerLabel) {
      triggerLabel.textContent = option.dataset.name || '';
    }

    const link = switcher.querySelector('[data-team-switcher-link]');
    if (link) {
      link.href = option.dataset.link || '#';
      link.textContent = option.dataset.linkText || '';
    }

    switcher.querySelectorAll('[data-team-switcher-option]').forEach((el) => {
      el.setAttribute('aria-selected', el === option ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-team-switcher]').forEach((switcher) => {
    const options = switcher.querySelectorAll('[data-team-switcher-option]');
    applyTeamOption(switcher, options[0]);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-team-switcher-trigger]');
    if (trigger) {
      const switcher = trigger.closest('[data-team-switcher]');
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        closeListbox(switcher);
      } else {
        openListbox(switcher);
      }
      return;
    }

    const option = event.target.closest('[data-team-switcher-option]');
    if (option) {
      const switcher = option.closest('[data-team-switcher]');
      applyTeamOption(switcher, option);
      closeListbox(switcher);
      return;
    }

    document.querySelectorAll('[data-team-switcher]').forEach((switcher) => {
      if (!switcher.contains(event.target)) closeListbox(switcher);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-team-switcher]').forEach((switcher) => closeListbox(switcher));
  });
  } catch(e) { console.error(e); }
})();

})();
